import { ITranslationRequest } from "../base/translation";
export interface ICreateTrademark {
  name: ITranslationRequest;
  note: ITranslationRequest;
  imageId: number;
  isSpecial: boolean;
  acceptedExchange: boolean;

  logoId: number;
  isNew?: boolean;
  hasOffers: boolean;
  exportPurchaseInvoiceReport: boolean;
  isOfferingFreeDelivery?: boolean;
  tagIds: number[];
  order: number;
  orderInCategory: number;
  minOrderValueForFreeDelivery: number;
  maxOrderValueForFreeDelivery: number;
  without_background?: boolean,
  without_background_logo?: boolean,

}

export interface IUpdateTrademark extends ICreateTrademark { }

export interface IExportTrademarkExcel {
  name: boolean;
  id: boolean;

  order: boolean;
  note: boolean;
}

export const colomnsExportTrademarkExcel = ["name", "id", "order", "note"];

export interface IExportPurchaseInvoiceReport {
  piece_min_quantity: number;
  piece_max_quantity: number;
  kilogram_min_quantity: number;
  kilogram_max_quantity: number;
  ounce_min_quantity: number;
  ounce_max_quantity: number;
}

export const purchaseInvoiceReportColumns = [
  "piece_min_quantity",
  "piece_max_quantity",
  "kilogram_min_quantity",
  "kilogram_max_quantity",
  "ounce_min_quantity",
  "ounce_max_quantity"
];
